import { Component, DestroyRef, inject, signal } from '@angular/core';
import { form, FormField, required } from '@angular/forms/signals';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { VendorSelect } from '../../../../utilities/components/vendor-select/vendor-select';
import { AssetTypeSelect } from '../../../../utilities/components/asset-type-select/asset-type-select';
import { AssetService } from '../../../../services/asset';
import { SpinnerLoaderDirective } from '../../../../utilities/directives/spinner-loader.directive';
import { NotificationService } from '../../../../utilities/services/notification.service';

@Component({
  selector: 'fs-model-modal',
  imports: [VendorSelect, FormField, AssetTypeSelect, SpinnerLoaderDirective],
  templateUrl: './model-modal.html',
  styleUrl: './model-modal.scss',
})
export class ModelModal {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly activeModal = inject(NgbActiveModal);
  private readonly assetService = inject(AssetService);
  private readonly notificationService = inject(NotificationService);

  private readonly modelModel = signal({
    name: '',
    assetVendorId: '',
    assetTypeId: '',
    enabled: false
  });
  protected deviceModel = form(this.modelModel, (schemaPath) => {
    required(schemaPath.name, { message: 'Inserire il nome del modello' });
    required(schemaPath.assetVendorId, { message: 'Selezionare il produttore' });
    required(schemaPath.assetTypeId, { message: 'Selezionare il tipo di asset' });
  });

  protected saveModelSubscription!: Subscription;

  protected saveModel() {
    this.deviceModel().markAsTouched();
    if (this.deviceModel().invalid()) return;

    const data = {
      name: this.deviceModel().value().name,
      assetType: { id: this.deviceModel().value().assetTypeId },
      assetVendor: { id: this.deviceModel().value().assetVendorId },
      enabled: this.deviceModel().value().enabled
    };
    this.saveModelSubscription = this.assetService.createDeviceModel(data).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe({
      next: () => {
        this.notificationService.showToast('Il modello è stato correttamente creato', { type: 'success' });
        this.activeModal.close('refresh')
      },
      error: () => {
        this.notificationService.showToast('Non è stato possibile creare il modello', { type: 'danger' });
        this.activeModal.close();
      }
    })
  }
}
